module.exports = __webpack_public_path__ + "img/chips50000.bc3659cf.png";